import type { ActivityOverviewStatusFilter } from '@sparkapp/shared-types';

type ListFilterKey = 'domainId' | 'skillId' | 'preferenceId' | 'physicalDeckId' | 'playTypeId';

/** Activities list URL matching an overview count. `all` omits status (the list defaults to non-archived). */
export function activityListHref(
  status: ActivityOverviewStatusFilter,
  filters: Partial<Record<ListFilterKey, number>>,
): string {
  const params = new URLSearchParams();
  if (status !== 'all') params.set('status', status);
  for (const [key, value] of Object.entries(filters)) if (value) params.set(key, String(value));
  return `/admin/activities?${params}`;
}
